import { inTometer, lbToton } from '@/tools/unit-conversion'

function unitFormat(num) {
  if (num) {
    return Number(inTometer(num).toFixed(3))
  }
  return 0
}

export class TruckSetting {
  constructor(info) {
    this.limitedVehicleWeight = info.limitedWeight ? Number(lbToton(info.limitedWeight).toFixed(3)) : 0
    this.weightPerAxle = info.weightPerAxle ? Number(lbToton(info.weightPerAxle).toFixed(3)) : 0
    this.vehicleHeight = unitFormat(info.height) > 50 ? 50 : unitFormat(info.height)
    this.vehicleWidth = unitFormat(info.width) > 50 ? 50 : unitFormat(info.width)
    this.vehicleLength = unitFormat(info.length) > 300 ? 300 : unitFormat(info.length)
    this.truckAxleCount = info.axleCount || 2
    this.trailersCount = info.trailersCount || 0
    this.hazardousGoods = info.shippedHazardousGoods || ''
  }

  toQueryParams() {
    const res = {}
    TruckSetting.KEYS.forEach(key => {
      res[key] = this[key]
    })
    return res
  }
}

TruckSetting.KEYS = ['limitedVehicleWeight', 'weightPerAxle', 'vehicleHeight', 'vehicleWidth', 'vehicleLength', 'truckAxleCount', 'trailersCount', 'hazardousGoods']
